import { render, staticRenderFns } from "./OverallGrade.vue?vue&type=template&id=ded12b1c&scoped=true&"
import script from "./OverallGrade.vue?vue&type=script&lang=js&"
export * from "./OverallGrade.vue?vue&type=script&lang=js&"
import style0 from "./OverallGrade.vue?vue&type=style&index=0&id=ded12b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded12b1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
